import { Box, styled, Typography } from "@mui/material";

export const StyledBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: theme.spacing(2),
  padding: "12px 21px",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
  border: theme.borders.highlighted,
  background: theme.palette.custom.white,
  borderRadius: theme.borderRadius.radius.regular,
}));
export const StyledTypography = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.base.fontSize,
  fontWeight: theme.typography.fontWeight.bold,
  color: theme.palette.custom.orderName,
  paddingLeft: "12px",
  flexShrink: 0,
  [theme.breakpoints.down("xs")]: {
    fontSize: theme.typography.mini.fontSize,
  },
}));
export const StyledStatusMessage = styled(Typography)(({ theme }) => ({
  flex: 1,
  minWidth: 0,
  textAlign: "center",
  fontSize: theme.typography.small.fontSize,
  fontWeight: theme.typography.fontWeight.medium,
  color: theme.palette.custom.danger,
  lineHeight: 1.4,
  [theme.breakpoints.down("md")]: {
    textAlign: "left",
    fontSize: theme.typography.mini.fontSize,
  },
}));
